import {
  StatusOnlineIcon,
  CalendarIcon,
  CreditCardIcon,
  ServerIcon,
} from "@heroicons/react/outline";
import { CrawlerDetails } from "pages/crawler/components/jobs/types";
import { getOutputFormatDisplayText } from "pages/crawler/utils/outputFormatUtils";
import StatsCard, { StatItem } from "components/StatsCard";

export const CrawlerStatsCard = ({ details }: { details: CrawlerDetails | null }) => {
  const stats: StatItem[] = [
    { icon: StatusOnlineIcon, label: "Status", value: details?.status },
    { icon: CalendarIcon, label: "Created", value: details?.created },
    { icon: CreditCardIcon, label: "Avg. cost per job", value: details?.avgCostPerJob },
    { icon: ServerIcon, label: "Total credits spent", value: details?.totalCreditsSpent },
  ];

  return (
    <StatsCard
      stats={stats}
      parameters={
        <>
          <span className="inline-flex items-center px-3 py-1.5 text-xs rounded-md">
            <ServerIcon className="w-3 h-3 mr-1.5" />
            Output format: {getOutputFormatDisplayText(details?.outputFormat, details?.autoparse)}
          </span>
          <span className="inline-flex items-center px-3 py-1.5 text-xs rounded-md">
            <ServerIcon className="w-3 h-3 mr-1.5" />
            Device type: {details?.deviceType}
          </span>
          <span className="inline-flex items-center px-3 py-1.5 text-xs rounded-md">
            <ServerIcon className="w-3 h-3 mr-1.5" />
            Retry 404: {details?.retry404 ? "Enabled" : "Disabled"}
          </span>
        </>
      }
    />
  );
};

export default CrawlerStatsCard;
